import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { PLAYBACK_SESSION_CHECK_MUTATION } from "@/apollo/queries/playback";
import { useAddResumeMutation, useFullscreenApi, usePlaybackSessionCloseMutation } from "@/hooks";
import config from "@/lib/config";
import dayjs from "@/lib/day";
import debugLog from "@/lib/debugLog";
import { PlalaBeaconError, UNSUPPORTED_SCHEME_ERROR_MESSAGE } from "@/lib/errors";
import getVisitorId from "@/lib/getVisitorId";
import { liveStatus } from "@/lib/metaUtil";
import routes from "@/lib/routes";
import { useApolloClient } from "@apollo/client";
import { useCallback, useEffect, useRef, useState } from "react";
var beaconInterval = 30 * 1000;
export function usePlayerEventHandler(user, userLoading, deviceInfo, player, meta, entitlements, playbackAuth, playToken, displayOverlay, canplay) {
  var _playbackAuthRef$curr4, _playbackAuthRef$curr6;

  var callbacks = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : {};
  var client = useApolloClient();

  var _useState = useState(false),
      handled = _useState[0],
      setHandled = _useState[1];

  var resumeSending = useRef(false);
  var mounted = useRef(false);
  var metaRef = useRef();
  var vuid = useRef();
  var playingIntervalId = useRef();
  var beaconIntervalId = useRef();
  var liveCurrentTimeIntervalId = useRef(0);
  var seeking = useRef(false);
  var liveCurrentTime = useRef(0);
  var liveCurrentDuration = useRef(0);
  var playTimePercentage = useRef(0);
  var playbackAuthRef = useRef();
  var playTokenRef = useRef();
  var fsAPI = useFullscreenApi();

  var _useAddResumeMutation = useAddResumeMutation(),
      _useAddResumeMutation2 = _slicedToArray(_useAddResumeMutation, 2),
      addResumeMutation = _useAddResumeMutation2[0],
      loading = _useAddResumeMutation2[1].loading;

  var _usePlaybackSessionCl = usePlaybackSessionCloseMutation(),
      _usePlaybackSessionCl2 = _slicedToArray(_usePlaybackSessionCl, 1),
      sessionCloseMutation = _usePlaybackSessionCl2[0];

  playbackAuthRef.current = playbackAuth;
  playTokenRef.current = playToken;
  var logTrack = useCallback(function (event) {
    var _playbackAuthRef$curr, _user$currentProfile;

    var additionalParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // log_params:
    //   a: 4
    //   aid: 17
    //   cp: 6
    //   dc: 1
    //   fl: 1
    //   media_id: 8
    //   meta_id: 195
    //   psgk: "default"
    //   psid: "bf57765ffa0b4c069d61e1eedd05f675"
    //   service: "spod"
    //   uid: 17
    var meta = metaRef.current;
    var logParams = (_playbackAuthRef$curr = playbackAuthRef.current) === null || _playbackAuthRef$curr === void 0 ? void 0 : _playbackAuthRef$curr.log_params;

    if (["pause", "ended", "dismiss", "dispose", "error"].includes(event)) {
      clearInterval(playingIntervalId.current);
      playingIntervalId.current = null;
    }

    var episodeType = function (meta) {
      if (meta.is_live) {
        if (liveStatus(meta)) {
          return "live";
        } else if (meta.catch_up_flag) {
          return "catchup";
        }
      }

      return "vod";
    }(meta);

    var params = _objectSpread(_objectSpread({
      front_id: config.frontId,
      episode_type: episodeType,
      s: parseInt(player.currentTime(), 10),
      ts: +new Date(),
      vuid: vuid.current
    }, logParams), additionalParams);

    if (event != "beacon") {
      params.event = event;
    }

    if (["pause", "dismiss", "ended", "dispose"].includes(event)) {
      params.pt = player.currentTime();
    }

    if (user !== null && user !== void 0 && (_user$currentProfile = user.currentProfile) !== null && _user$currentProfile !== void 0 && _user$currentProfile.id) {
      params.profile_id = user.currentProfile.id;
    }

    if (user && user.test_flg) {
      params.fl = 1;
    }

    var rightIds = entitlements.map(function (entitle) {
      return entitle.right_id;
    });

    if (rightIds.length > 0) {
      params.right_id = rightIds.join(",");
    }

    var url = function () {
      if (event === "beacon") {
        return "".concat(config.logTrack.url, "/beacon");
      } else {
        return "".concat(config.logTrack.url, "/track");
      }
    }();

    debugLog(event, params);
    var qs = new URLSearchParams(params);
    return fetch("".concat(url, "?").concat(qs)).catch(function (e) {
      return console.error(e);
    });
  }, [user, meta, entitlements, player, playbackAuthRef.current, vuid]);
  var plalaBeacon = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _config$plalaBeacon, url, clientId, body;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (playTokenRef.current) {
              _config$plalaBeacon = config.plalaBeacon, url = _config$plalaBeacon.url, clientId = _config$plalaBeacon.clientId;
              body = JSON.stringify({
                play_token: playTokenRef.current,
                stop_position: Math.floor(player.currentTime())
              });
              fetch(url, {
                method: "POST",
                mode: "cors",
                body: body,
                headers: {
                  "Content-Type": "application/json",
                  "X-Client": clientId
                }
              }).then(function (res) {
                return res.json();
              }).then(function (res) {
                // console.log(res);
                // TODO: レスポンスをみて再生を止める必要がある
                // 1002103
                // 1002201
                // {
                //   "status": "NG",
                //   "errorno": "1002103"
                // }
                var stopStatus = ["1002103", "1002201"];

                if (res.status === "NG" && stopStatus.includes(res === null || res === void 0 ? void 0 : res.errorno)) {
                  player.dispose();
                  var error = new PlalaBeaconError(null, res.errorno);
                  displayOverlay({
                    reason: "error",
                    error: error
                  });
                }
              }).catch(function (e) {
                console.error(e);
                player.dispose();
                var error = new PlalaBeaconError(null, "9999");
                displayOverlay({
                  reason: "error",
                  error: error
                });
                window.plugin.fireError(9999, error.message + "（バリュープランポーリングエラーの可能性あり）");
              });
            }

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [player, playTokenRef.current, displayOverlay]);
  var sendResume = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _playbackAuthRef$curr2, _playbackAuthRef$curr3;

    var liveResume,
        meta,
        psid,
        _meta$tvShow,
        resume,
        reachToEnd,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            liveResume = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;

            if (!resumeSending.current) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return");

          case 3:
            if (!loading) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return");

          case 5:
            if (!(player && isNaN(player.duration()))) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt("return");

          case 7:
            if (!(player && player.isLive() && !liveResume)) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return");

          case 9:
            meta = metaRef.current;
            psid = (_playbackAuthRef$curr2 = playbackAuthRef.current) === null || _playbackAuthRef$curr2 === void 0 ? void 0 : (_playbackAuthRef$curr3 = _playbackAuthRef$curr2.log_params) === null || _playbackAuthRef$curr3 === void 0 ? void 0 : _playbackAuthRef$curr3.psid;

            if (!(user && meta && player && psid)) {
              _context2.next = 19;
              break;
            }

            resumeSending.current = true;
            resume = player.isLive() ? -1 : parseInt(player.currentTime(), 10);

            if (liveResume) {
              resume = liveCurrentTime.current;
            }

            reachToEnd = player.ended() ? true : false;
            _context2.next = 18;
            return addResumeMutation({
              variables: {
                resume: resume,
                metaId: Number(meta.id),
                groupedMetaId: meta.tvShow ? Number((_meta$tvShow = meta.tvShow) === null || _meta$tvShow === void 0 ? void 0 : _meta$tvShow.id) : null,
                psid: psid,
                reachToEnd: reachToEnd
              }
            });

          case 18:
            resumeSending.current = false;

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [resumeSending, loading, user, player, playbackAuthRef.current, liveCurrentTime.current]);
  var sessionCheck = useCallback(function () {
    client.mutate({
      mutation: PLAYBACK_SESSION_CHECK_MUTATION,
      variables: {
        sessionId: playbackAuthRef.current.playback_session_id
      }
    }).then(function (_ref3) {
      var _data$playbackSession;

      var data = _ref3.data;

      if (!(data !== null && data !== void 0 && (_data$playbackSession = data.playbackSessionCheck) !== null && _data$playbackSession !== void 0 && _data$playbackSession.result)) {
        window.location.reload();
      }
    }).catch(function (e) {
      // サーバーが落ちた場合、networkErrorで返ってくる
      if (e.networkError) {
        window.plugin.fireError(99999, UNSUPPORTED_SCHEME_ERROR_MESSAGE[99999]);
      }

      console.log(e);
      window.location.reload();
    });
  }, [(_playbackAuthRef$curr4 = playbackAuthRef.current) === null || _playbackAuthRef$curr4 === void 0 ? void 0 : _playbackAuthRef$curr4.playback_session_id]);
  var sessionClose = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _playbackAuthRef$curr5;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(playbackAuth.current && (_playbackAuthRef$curr5 = playbackAuthRef.current) !== null && _playbackAuthRef$curr5 !== void 0 && _playbackAuthRef$curr5.playback_session_id)) {
              _context3.next = 3;
              break;
            }

            _context3.next = 3;
            return sessionCloseMutation({
              variables: {
                sessionId: playbackAuthRef.current.playback_session_id
              }
            });

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [(_playbackAuthRef$curr6 = playbackAuthRef.current) === null || _playbackAuthRef$curr6 === void 0 ? void 0 : _playbackAuthRef$curr6.playback_session_id]); // イベントハンドリング
  // beacon 視聴履歴、ブックマーク
  // paraviをみるとon playでplaybacksession checkをコールして invalid_grantになったらリロードしてた
  // セッションを取得した直後にチェックが必要なのか？

  var eventHandler = useCallback(function () {
    function execCallbck(event) {
      if (callbacks[event]) {
        callbacks[event]();
      }
    }

    player.on("loadstart", function () {
      // 既存コードではEdgeでDRMがある場合playreadyに対応しているか確認している
      execCallbck("loadstart");
    });
    player.on("canplay", function () {
      // 既存コードではvideoタグにtitleを設定してstate canplayをtrueにしている
      execCallbck("canplay");
    });
    player.on("firstplay", function () {
      logTrack("firstplay");
      sendResume();
      execCallbck("firstplay");
    });
    player.on("play", function () {
      // beacon startを送信
      // audienceLog Playを送信
      logTrack("play");
      execCallbck("play"); // playback/sessionをチェック

      sessionCheck();
    });
    player.on("playing", function () {
      // beacon playingを30secごとに送信
      if (!playingIntervalId.current) {
        playingIntervalId.current = setInterval(function () {
          logTrack("beacon");
        }, beaconInterval);
      }

      if (!beaconIntervalId.current) {
        beaconIntervalId.current = setInterval(function () {
          plalaBeacon();
        }, beaconInterval);
      }

      if (!liveCurrentTimeIntervalId.current) {
        liveCurrentTimeIntervalId.current = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var currentTime, seekableStart, startAt, endAt, encodeDuration, liveResumeFlag;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  currentTime = player.currentTime();
                  seekableStart = player.seekableStart(); // 再生位置が移動した場合にライブの再生位置を上書きしないようにする

                  if (currentTime - seekableStart > liveCurrentTime.current) {
                    liveCurrentTime.current = parseInt(currentTime - seekableStart, 10);
                  } // ライブ配信が終了した場合


                  if (!(liveCurrentDuration.current === Infinity && player.duration() !== Infinity)) {
                    _context4.next = 14;
                    break;
                  }

                  startAt = dayjs(meta.encode_start_date);
                  endAt = dayjs(meta.encode_end_date);
                  encodeDuration = endAt.diff(startAt, "seconds"); // メタの条件かつ再生位置がライブ位置ではない場合

                  if (!(meta.is_live && meta.start_over_flag && meta.catch_up_flag && Math.abs(encodeDuration - liveCurrentTime.current) > 30)) {
                    _context4.next = 14;
                    break;
                  }

                  liveResumeFlag = true;
                  _context4.next = 11;
                  return sendResume(liveResumeFlag);

                case 11:
                  _context4.next = 13;
                  return sessionClose();

                case 13:
                  window.location.href = "".concat(routes.watch(meta.id), "?liveresume=1&resumepoint=").concat(liveCurrentTime.current);

                case 14:
                  liveCurrentDuration.current = player.duration();

                case 15:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        })), 500);
      }

      execCallbck("playing"); // audienceLog Playingを30secごとに送信
    });
    player.on("pause", function () {
      // 後追いなしの場合は停止させない
      if (player.isLive() && meta.is_live && !meta.start_over_flag) {
        player.play();
      } else if (!player.ended() && !player.seeking()) {
        // audienceLog Pauseを送信
        // beacon Pause
        logTrack("pause");
        sendResume();
      }

      execCallbck("pause");
    });
    player.on("timeupdate", function () {
      // currentTimeがdurationの何％かチェックして
      // 25%,50%,75%のときにmilestoneイベントを送る
      // シークでもどった時には発火しないようにする
      // シークで一気に進んだ場合は全部送る
      var currentTime = player.currentTime();
      var duration = player.duration();
      [25, 50, 75].filter(function (per) {
        return per > playTimePercentage.current;
      }).forEach(function (per) {
        // 複数回実行されないために、ここでもう一度filterで使った条件をいれる
        if (per > playTimePercentage.current && currentTime > duration * (per / 100)) {
          playTimePercentage.current = per;
          logTrack("milestone", {
            percentage: per
          });
        }
      });
      execCallbck("timeupdate");
    });
    player.on("seeking", function () {
      // 既存ではwaitingRetryという処理を実行していた
      // 今回必要になるか不明
      if (!seeking.current) {
        seeking.current = true;
        logTrack("seekStart");
      }

      debugLog("seeking");
      execCallbck("seeking");
    });
    player.on("seeked", function () {
      // 既存では以下の問題があったようだがどうなのか
      // iOSのfiarplayだとシーク後に音声のみになってしまう
      seeking.current = false;
      logTrack("seekEnd");
      debugLog("seeked");
      execCallbck("seeked");
    });
    player.on("waiting", function () {
      // 既存では以下の問題があったようだがどうなのか
      // AESのライブがm3u8にEndListがなく、keyリクエストが404になるだけで再生が止められないので
      // LIVEでwaitingが発火したときに配信期間が過ぎていたら再生を止める
      debugLog("waiting");
      execCallbck("waiting");
    });
    player.on("renditionswitch", function () {
      debugLog("renditionswitch", player.rendition());
    });
    player.on("ended", function () {
      // beacon End
      logTrack("ended");
      clearInterval(beaconIntervalId.current);
      beaconIntervalId.current = null; // audienceLog Endを送信

      sendResume();
      execCallbck("ended");
    });
    player.on("suspend", function () {
      logTrack("suspend");
      execCallbck("suspend");
      debugLog("suspend");
    });
    player.on("dispose", function () {
      logTrack("dispose");
      clearInterval(beaconIntervalId.current);
      beaconIntervalId.current = null;
      execCallbck("dispose");
    });
    player.on("error", function () {
      clearInterval(playingIntervalId.current);
      clearInterval(beaconIntervalId.current);
      beaconIntervalId.current = null;
      clearInterval(liveCurrentTimeIntervalId.current);
      logTrack("error");
      sendResume();
      sessionClose();
      execCallbck("error"); // beacon stopを送信
      // audienceLog Stopを送信
    });
  }, [player, callbacks, playbackAuthRef.current, plalaBeacon]);
  useEffect(function () {
    mounted.current = true;
    getVisitorId().then(function (id) {
      return vuid.current = id;
    }); // watchページないで別のwatchページに遷移した時に、ページ遷移する前にmetaだけ更新されてレジュームが適切に送信されないので
    // refでメタをもっておいて更新されないようにする

    metaRef.current = meta;
    return function () {
      mounted.current = false;
    };
  }, []);
  useEffect(function () {
    var hidden, visibilityChange;

    if (typeof document.hidden !== "undefined") {
      hidden = "hidden";
      visibilityChange = "visibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
      hidden = "msHidden";
      visibilityChange = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
      hidden = "webkitHidden";
      visibilityChange = "webkitvisibilitychange";
    }

    var handlePageHide = function handlePageHide() {
      if (player && !player.ended() && !player.paused()) {
        sendResume();
      }
    };

    var handleVisibilityChange = function handleVisibilityChange() {
      if (document[hidden]) {
        handlePageHide();
      }
    };

    var handleBeforeUnload = function handleBeforeUnload() {
      logTrack("dismiss");
    };

    var handleFullscreenChange = function handleFullscreenChange() {
      if (player && !player.ended()) {
        if (player.isFullscreen()) {
          logTrack("fullscreen");
        } else {
          logTrack("exitFullscreen");
        }
      }
    };

    window.addEventListener(visibilityChange, handleVisibilityChange);
    window.addEventListener("beforeunload", handleBeforeUnload);

    if (deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isSafari) {
      window.addEventListener("pagehide", handlePageHide);
    }

    document.addEventListener(fsAPI.fullscreenchange, handleFullscreenChange);
    return function () {
      clearInterval(playingIntervalId.current);
      clearInterval(beaconIntervalId.current);
      beaconIntervalId.current = null;
      clearInterval(liveCurrentTimeIntervalId.current);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener(visibilityChange, handleVisibilityChange);

      if (deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isSafari) {
        window.removeEventListener("pagehide", handlePageHide);
      }

      document.removeEventListener(fsAPI.fullscreenchange, handleFullscreenChange);
    };
  }, [deviceInfo, player, playbackAuthRef.current, fsAPI]);
  useEffect(function () {
    if (!handled && player && playbackAuthRef.current && !userLoading && canplay) {
      setHandled(true);
      eventHandler();
    }

    return function () {
      if (!mounted.current) {
        sendResume();
      }
    };
  }, [handled, player, playbackAuthRef.current, userLoading, canplay]);
}